// extracted by mini-css-extract-plugin
module.exports = {"table":"MonthlyCleaningInvoicingModal_table__1wTn_"};